export const isValidImage = (image?: string): boolean => {
  if (!image) return false

  if (image.trim() === '') return true

  try {
    const url = new URL(image)
    const pathname = url.pathname.toLowerCase()
    return /\.(jpg|png|gif)$/.test(pathname)
  } catch (e) {
    return false
  }
}

export const isValidVideo = (video?: string): boolean => {
  if (!video) return false

  if (video.trim() === '') return true

  try {
    const url = new URL(video)
    const pathname = url.pathname.toLowerCase()
    return /\.(mp4|mov|webm)$/.test(pathname)
  } catch (e) {
    return false
  }
}

export const isValidHTML = (html?: string): boolean => {
  if (!html) return false

  if (html.trim() === '') return true

  try {
    const tagRegex = /<\/?([a-zA-Z][a-zA-Z0-9]*)\b[^>]*>/g
    const openTags: string[] = []
    let match: string[] | null

    while ((match = tagRegex.exec(html)) !== null) {
      const fullTag = match[0]
      const tagName = match[1].toLowerCase()

      const selfClosingTags = [
        'img',
        'br',
        'hr',
        'input',
        'meta',
        'link',
        'area',
        'base',
        'col',
        'embed',
        'source',
        'track',
        'wbr',
      ]

      if (fullTag.startsWith('</')) {
        if (
          openTags.length === 0 ||
          openTags[openTags.length - 1] !== tagName
        ) {
          return false
        }
        openTags.pop()
      } else if (fullTag.endsWith('/>') || selfClosingTags.includes(tagName)) {
        continue
      } else {
        openTags.push(tagName)
      }
    }

    if (openTags.length > 0) {
      return false
    }

    const parser = new DOMParser()
    const doc = parser.parseFromString(html, 'text/html')

    const errorNode = doc.querySelector('parsererror')
    if (errorNode) {
      return false
    }

    const hasValidContent =
      doc.body.children.length > 0 || doc.body.textContent?.trim() !== ''

    return hasValidContent
  } catch (error) {
    return false
  }
}
